








































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import { IPayData } from '@/apps/open/types/pay'
import { PAY_CALLBACK_ARG, PAY_CALLBACK_URL } from '@/apps/open/constants'
import { setVasCallkack } from '@/apps/open/services/vasopen'
import InputFormDialogBody from '@/apps/open/components/DialogBodys/InputForm.vue'
import { onRequestError } from '@/apps/open/utils'

@Component({
  data: () => ({
    CALLBACK_URL: PAY_CALLBACK_URL,
    PAY_DOC_URL: PAY_CALLBACK_ARG
  }),
  components: {
    Button
  }
})
export default class PaySetting extends Vue {
  @Prop() vasInfo!: IPayData

  hidePaySecret = true

  get appId () {
    return this.$route.params.id
  }

  get serviceId () {
    return (this.vasInfo as any).service_list.map((item:any) => item.id).filter((item:any) => item).join(',')
  }

  get subjectId () {
    return (this.vasInfo as any).service_list.map((item:any) => item.retail_subject).filter((item:any) => item).join(',')
  }

  switchPaySecret () {
    this.hidePaySecret = !this.hidePaySecret
  }

  showServiceInfo () {
    this.$confirm(
      `
        <div>
          <div style="color: #999">服务ID（service_id是开发者对接后可用的服务）</div>
          <div>${this.serviceId}</div>
          <div style="margin-top: 10px; color: #999">购买内容（subject是服务类型为第三方应用服务时传的服务ID）</div>
          <div>${this.subjectId}</div>
        </div>
      `,
      '支付服务参数',
      {
        dangerouslyUseHTMLString: true,
        cancelButtonText: '关闭',
        showConfirmButton: false
      }
    )
  }

  viewCallbackUrl () {
    this.$dialog.show({
      title: '支付回调地址',
      body: `<div style="word-break: break-all;">${this.vasInfo.cb_url}</div>`,
      buttons: [
        { text: '取消' },
        { text: '修改', type: 'primary', fn: this.setCallbackUrl }
      ]
    })
  }

  setCallbackUrl () {
    this.$dialog.show({
      title: '支付回调地址配置',
      body: InputFormDialogBody,
      bodyProps: {
        value: this.vasInfo.cb_url,
        rules: [
          { required: true, message: '请输入支付回调地址' },
          { type: 'url', message: '请输入正确的支付回调地址' }
        ],
        placeholder: '请输入支付回调地址',
        submit: this.submitCallbackUrl
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  submitCallbackUrl (value: string) {
    value = value.trim()
    setVasCallkack(this.appId, { cb_url: value })
      .then(() => {
        this.vasInfo.cb_url = value || ''
        this.$dialog.close()
        this.$message.success('支付回调地址保存成功')
      }).catch((error) => {
        onRequestError(error)
      })
  }
}
